import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  font-family: 'Marck Script', cursive;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Frame = styled.div`
  position: absolute;
`;
Frame.displayName = 'Frame';

export const FrameContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;
FrameContainer.displayName = 'FrameContainer';

export const Time = styled.div`
  align-items: center;
  color: #ffffff;
  display: flex;
  font-size: 64px;
  font-style: normal;
  font-weight: normal;
  height: 111px;
  justify-content: center;
  left: 12px;
  letter-spacing: 0.02em;
  line-height: 64px;
  position: relative;
  text-align: center;
  text-shadow: 0px 0px 15px #e32126;
  top: 15px;
  width: 480px;
  z-index: 2;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #ffffff;
  font-size: 40px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.02em;
  line-height: 48px;
  margin-bottom: 10px;
  text-align: center;
  text-shadow: -1px 0 #f68a8a, 0 1px #f68a8a, 1px 0 #f68a8a, 0 -1px #f68a8a;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
